import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';

import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { createChart, formatDate } from 'src/app/shared/commen-function-file';
import { AssetDashboardDetailsComponent } from '../asset-dashboard-details/asset-dashboard-details.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-asset-dashboard',
  templateUrl: './asset-dashboard.component.html',
  styleUrls: ['./asset-dashboard.component.scss'],
})
export class AssetDashboardComponent implements OnInit {
  taskFromDateForAllGraph: any;
  taskToDateForAllGraph: any
  selectGraphType: any = 'bar';
  dropdownSettings: IDropdownSettings = {};
  taskFromDate: any;
  taskToDate: any;
  selectedYearForAsset: any;
  currentYearSelected: any;
  loggedInUserName: any | null;
  subModuleButtonColor: any | null;
  buttonColorName: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  pmsYears: any = [];
  fromYear: any;
  toYear: any;

  selectedYearForDashboard: any;
  isAssetTypeIcon: any = 'bar';
  isApprovedByFinanceIcon: any = 'bar';
  isFinanceAmountPaidIcon: any = 'bar';
  isApprovedByPaidAmountIcon: any = 'bar';
  isAssetTypeTable: any = false;
  isAsseTableGraphOne: any = false;
  isApprovedByFinanceTable: any = false;
  isApprovedByPaidAmountTable: any = false;
  selectedFromDated: any;
  selectedtoDated: any;
  isswitchhowManyTimeRepairedAssetIcon: any = 'bar';
  isswitchhowManyTimeRepairedAssetTable: any = false;
  selectGraphThirdType: any = 'bar';
  isswitchhowManyDaysToAssignAssetIcon: any = 'bar';
  isswitchhowManyDaysToAssignAssetTable: any = false;
  selectGraphFourthType: any = 'bar';
  selectGraphTwoType: any = 'bar';
  reimbursementTypeTable: any;
  isRepairedByAssetIcon: any = 'bar';
  isRepairedByAssetTable: boolean = false;
  assetallData: any;
  totalassetCount: any = [];
  isAsseTableGraphTwo: any = [];
  selectedYearForAsset2: any;
  selectedYearForAsset3: any;
  selectedYearForAsset1: any;
  selectedYearForAsset4: any;
  constructor(public router: Router, private httpService: HttpService, private encryptionService: EncryptionService,
    private config: Config, private activatedroute: ActivatedRoute, public sharedService: SharedService, public dialog: MatDialog,
    private fb: FormBuilder, private datePipe: DatePipe, private cdRef: ChangeDetectorRef, private PdfDownload: PdfDownloadService
  ) {

  }

  ngOnInit() {

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.getpmsyearlist();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  processAllGraphDateRange() {

  }

  selectedYearForCompetency: any = null;

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);
      this.getAllAssetData('bar')
      this.NewassetAllocationData();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForAsset1 = selectedYearObj?.year;
      this.selectedYearForAsset2 = selectedYearObj?.year;
      this.selectedYearForAsset3 = selectedYearObj?.year;
      this.selectedYearForAsset4 = selectedYearObj?.year;
      // this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
      // this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getAllAssetData('bar')
      this.NewassetAllocationData();

    }
  }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       // if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //       //   yearValue = `${currentYear}-${currentYear}`;
  //       // } else {
  //       //   yearValue = `${currentYear}-${currentYear + 1}`;
  //       // }
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }
  //       if (ele?.year == yearValue) {
  //         this.selectedYearForAsset = ele?.year;
  //         this.selectedYearForAsset1 = ele?.year;
  //         this.selectedYearForAsset2 = ele?.year;
  //         this.selectedYearForAsset3 = ele?.year;
  //         this.selectedYearForAsset4 = ele?.year;
  //         this.selectedYearForDashboard = ele?.year;
  //         this.currentYearSelected = ele?.year;

  //         // this.viewDashboardExpenseByYear(this.selectedYearForDashboard);


  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });


  //     this.getAllAssetData('bar')

  //   });

  // }

  // Dashboard Year
  viewDashboardExpenseByYear(year: any) {
    console.warn("inside viewDashboardExpenseByYear " + year);
    this.selectedYearForDashboard = year;
    this.selectedYearForAsset = year;
    this.currentYearSelected = year

    this.selectGraphType = this.selectGraphType ? this.selectGraphType : 'bar';
    // this.getAllAssetData(this.reimbursementTypeCount, this.selectGraphType, this.selectedYearForDashboard, '', '');
    // this.getApprovedPaidAmountByCount(this.selectGraphType, this.selectedYearForDashboard, '', '');


  }

  viewAssetYear(year: any, graphNo: any) {
    this.taskFromDate = null;
    this.taskToDate = null;


    if (graphNo == 'first') {
      this.selectedYearForAsset1 = year
      this.graphFirst(this.isAssetTypeIcon)
    }
    else if (graphNo == 'second') {
      this.selectedYearForAsset2 = year;
      this.graphSecond(this.isRepairedByAssetIcon)
    } else if (graphNo == 'third') {
      this.selectedYearForAsset3 = year;
      this.graphThird(this.isswitchhowManyTimeRepairedAssetIcon)
    }
    else if (graphNo == 'fourth') {
      this.selectedYearForAsset4 = year;
      this.graphFourth(this.isswitchhowManyDaysToAssignAssetIcon)
    }
    else if (graphNo == 'allDashBoard') {
      this.selectedYearForAsset1 = year;
      this.selectedYearForAsset2 = year;
      this.selectedYearForAsset3 = year;
      this.selectedYearForAsset4 = year;
      this.graphFirst(this.isAssetTypeIcon);
      this.graphSecond(this.isRepairedByAssetIcon);
      this.graphThird(this.isswitchhowManyTimeRepairedAssetIcon)
      this.graphFourth(this.isswitchhowManyDaysToAssignAssetIcon)
      this.NewassetAllocationData();
    } else { }
  }
  switchAssettypeGraph(graphType: any) {
    this.selectGraphType = graphType;
    this.isAssetTypeIcon = graphType;
    this.isAssetTypeTable = false;
    this.taskFromDate = null;
    this.taskToDate = null;
    this.graphFirst(this.selectGraphType);

  }

  switchReimbursementTypeTable() {
    this.selectGraphType = 'table';
    this.isAssetTypeIcon = '';
    this.isAssetTypeTable = true;

  }

  // Start For Second One
  switchrepaiedAssetGraph(graphType: any) {
    this.selectGraphTwoType = graphType;
    this.isRepairedByAssetIcon = graphType;
    this.isRepairedByAssetTable = false;
    this.graphSecond(this.selectGraphTwoType);

  }
  switchrepaiedAssetGraphForTable() {
    this.selectGraphTwoType = 'table';
    this.isRepairedByAssetIcon = '';
    this.isRepairedByAssetTable = true;

  }

  switchhowManyTimeRepairedAsset(graphType: any) {
    this.selectGraphThirdType = graphType;
    this.isswitchhowManyTimeRepairedAssetIcon = graphType;
    this.isswitchhowManyTimeRepairedAssetTable = false;

    this.graphThird(graphType)
  }
  switchhowManyTimeRepairedAssetTable() {
    this.selectGraphThirdType = 'table';
    this.isswitchhowManyTimeRepairedAssetIcon = '';
    this.isswitchhowManyTimeRepairedAssetTable = true;
  }
  switchhowManyDaysToAssignAsset(graphType: any) {
    this.selectGraphFourthType = graphType;
    this.isswitchhowManyDaysToAssignAssetIcon = graphType;
    this.isswitchhowManyDaysToAssignAssetTable = false;
    this.graphFourth(this.selectGraphFourthType);
  }
  switchhowManyDaysToAssignAssetTable() {
    this.selectGraphThirdType = 'table';
    this.isswitchhowManyDaysToAssignAssetIcon = '';
    this.isswitchhowManyDaysToAssignAssetTable = true;
    // this.selectedYearForAsset4 = this.selectedYearForAsset;
  }
  getAllAssetData(graphType: any) {

    this.graphFirst(graphType);
    this.graphSecond(graphType);
    this.graphThird(graphType);
    this.graphFourth(graphType);
    setTimeout(() => {
      this.NewassetAllocationData();
    }, 500)

  }
  passDataForDetailView: any;
  totalrepairedAsset: any;
  totalCountRecivedAsset: any;
  checkAuthority: any;
  graphFirst(graphType: any) {

    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset1}`)
      .subscribe((response: any) => {

        let dataForOnlyAuthority = response.data.filter((elm: any) => elm.authorityName == this.loggedInUserName && elm.userId != null);
        this.checkAuthority = dataForOnlyAuthority;
        console.log(this.checkAuthority);

        let assetData: any = [];
        if (this.loggedInUserRole == 'HR Admin') {
          assetData = response.data.filter((elm: any) => elm.userId != null);
        } else if (dataForOnlyAuthority && this.loggedInUserRole != 'HR Admin') {
          assetData = dataForOnlyAuthority
        }
        this.assetallData = assetData;
        this.passDataForDetailView = assetData;
        let returnasset = assetData.filter((elm: any) => elm.authorityDepartmentComment == 'RECEIVED_AFTER_EXIT');
        this.totalCountRecivedAsset = returnasset.length;
        let assetCountArray: any = []
        assetData.map((record: any) => {
          if (!assetCountArray.some((elm: any) => elm.assetName == record.assetName)) {
            assetCountArray.push(record)
          }
        });

        this.totalassetCount = assetCountArray.length

        //for First graph
        const transformedData: TransformedData = Object.values(
          this.assetallData.reduce((acc: any, item: any) => {
            const assetName = item.assetName;
            if (!acc[assetName]) {
              acc[assetName] = {
                xAxisValueData: assetName,
                seriesValueOneData: 0,
              };
            }
            acc[assetName].seriesValueOneData += 1; // Increment employee count for the asset
            return acc;
          }, {})
        );


        this.isAsseTableGraphOne = transformedData;
        // Add metadata properties to the transformed data
        transformedData.xAxisName = 'Asset Name';
        transformedData.yAxisName = 'Employee Count';
        transformedData.seriesLabelOne = 'Count';
        transformedData.seriesLabelTwo = '';
        // Dynamically render the graph based on graphType
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };
        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedData, 'bar-line-chart', 'single');
        }


      })
  }
  graphSecond(graphType: any) {
    this.httpService.callGetService(`${this.config.assetAllocationSecondGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset2}`)
      .subscribe((response: any) => {
        console.log(response.data);

        let assetSecondGraphData = response.data.filter((elm: any) => elm.averageRepairDay !== 0.0);
        console.log(assetSecondGraphData);

        const transformedDataForRepaired: TransformedData = Object.values(
          assetSecondGraphData.reduce((acc: any, item: any) => {
            const assetName = item.assetName;

            if (!acc[assetName]) {
              acc[assetName] = {
                xAxisValueData: assetName,
                seriesValueOneData: 0,
              };
            }

            // Increment employee count for the asset
            acc[assetName].seriesValueOneData += item.averageRepairDay
              ? parseFloat(item.averageRepairDay) // Add repair time if it exists
              : 0;

            return acc;
          }, {})
        );



        this.isAsseTableGraphTwo = transformedDataForRepaired;


        // Add metadata properties to the transformed data
        transformedDataForRepaired.xAxisName = 'Asset Name';
        transformedDataForRepaired.yAxisName = 'Asset Repaired Day Count';
        transformedDataForRepaired.seriesLabelOne = 'Count';
        transformedDataForRepaired.seriesLabelTwo = '';
        // Dynamically render the graph based on graphType
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };

        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedDataForRepaired, 'bar-line-repaired-chart', 'single');
        }
      })
  }
  isAssetTableGraphThird: any = []
  repairedAssetCount: any = []
  graphThird(graphType: any) {
    this.httpService.callGetService(`${this.config.assetAllocationThirdGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset3}`)
      .subscribe((response: any) => {
        let assetSecondThirdData: any = [];
        let repairedassetcount: any = [];
        let dataForOnlyAuthority = response.data.filter((elm: any) => elm.authorityName == this.loggedInUserName);
        if (this.loggedInUserRole == 'HR Admin') {
          repairedassetcount = response.data;
        } else if (dataForOnlyAuthority.length > 0 && this.loggedInUserRole != 'HR Admin') {
          repairedassetcount = dataForOnlyAuthority
        }
        this.repairedAssetCount = repairedassetcount.filter((elm: any) => elm.statusChangeCount != 0);
        assetSecondThirdData = repairedassetcount;

        this.totalrepairedAsset = this.repairedAssetCount.length;
        console.log(assetSecondThirdData.length);

        let transformedDataForRepaired = [];
        transformedDataForRepaired = assetSecondThirdData.map((item: any) => ({
          xAxisValueData: item.assetName,
          seriesValueOneData: item.statusChangeCount
        }));

        this.isAssetTableGraphThird = transformedDataForRepaired;
        // Add metadata properties to the transformed data
        transformedDataForRepaired.xAxisName = 'Asset Name';
        transformedDataForRepaired.yAxisName = 'Asset Repaired Count';
        transformedDataForRepaired.seriesLabelOne = 'Count';
        transformedDataForRepaired.seriesLabelTwo = '';
        // Dynamically render the graph based on graphType
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };

        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedDataForRepaired, 'bar-line-asset-repaired-chart', 'single');
        }
      })
  }

  // --------------------fourth Graph ----------
  isAssetTableGraphFourth: any = []
  getListForAuthority: any = [];
  selectedAuthority: any = []
  graphFourth(graphType: any) {
    this.httpService.callGetService(`${this.config.assetAllocationFourthGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}`)
      .subscribe((response: any) => {

        let assetFourthGraphData: any = [];
        if (this.selectedAuthority.length > 0) {
          console.log("inside if");

          let authorityName = this.selectedAuthority.map((elm: any) => elm.name);
          console.log(authorityName);

          assetFourthGraphData = response.data.filter((elm: any) => authorityName.includes(elm.authorityName));
        } else {
          console.log("inside else ");
          assetFourthGraphData = response.data;
        }
        let dataforDD = response.data;
        this.getListForAuthority = [];
        let emptyAuthority: any = []
        dataforDD.forEach((ele: any, index: any) => {
          let obj = {
            id: index,
            name: ele.authorityName,
          }
          emptyAuthority.push(obj);

        });
        emptyAuthority.filter((elm: any) => {
          if (!this.getListForAuthority.some((record: any) => record.name == elm.name)) {
            this.getListForAuthority.push(elm)
          }
        })
        // let transformedDataForRepaired = [];
        // transformedDataForRepaired = assetFourthGraphData.map((item: any) => ({
        //   xAxisValueData: item.assetName,
        //   seriesValueOneData: item.avgAllocatingDate
        // }));
        
        // Filter out entries where avgAllocatingDate === 0
        const transformedDataForRepaired = assetFourthGraphData
          .filter((item: any) => item.avgAllocatingDate > 0)
          .map((item: any) => ({
            xAxisValueData: item.assetName,
            seriesValueOneData: item.avgAllocatingDate
          }));



        this.isAssetTableGraphFourth = transformedDataForRepaired;
        // Add metadata properties to the transformed data
        transformedDataForRepaired.xAxisName = 'Asset Name';
        transformedDataForRepaired.yAxisName = 'Asset Allocation Days Count';
        transformedDataForRepaired.seriesLabelOne = 'Count';
        transformedDataForRepaired.seriesLabelTwo = '';
        // Dynamically render the graph based on graphType
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };

        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedDataForRepaired, 'bar-line-asset-allocatiom-chart', 'single');
        }
      })
  }
  onSelectAuthority() {
    console.log(this.selectedAuthority);
    this.graphFourth(this.selectGraphFourthType);
  }
  onDelectAuthority() {
    this.graphFourth(this.selectGraphFourthType);
  }
  selectAllAuthority(event: any) {
    this.selectedAuthority = event;
    this.graphFourth(this.selectGraphFourthType);
  }
  onDeSelectAllAuthority() {
    this.selectedAuthority = [];
    this.graphFourth(this.selectGraphFourthType);
  }


  // Usage for Line Chart
  assetLineGraph(data: any, idSelector: any, graphType: any): void {
    createChart(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }
  // Usage for Bar Chart
  assetBarGraph(data: any, idSelector: any, graphType: any): void {


    createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }
  processFirstGraphDateRange(): void {
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;



    } else {
      console.log('No filtering applied for Graph 1, returning all data');
    }
  }


  downloadChartAsPDF(type: any): void {


    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
    const formattedFromDate = (this.selectedFromDated == undefined) ? '' : formatDate(this.selectedFromDated);
    const formattedtoDate = (this.selectedtoDated == undefined) ? '' : formatDate(this.selectedtoDated);

    if (type == 'Asset-Employee-Count') {
      var idSelector = (this.selectGraphType == 'table') ? 'asset-type-table-data' : 'bar-line-chart';

    } else if (type == 'Asset Resolution') {
      var idSelector = (this.selectGraphTwoType == 'table') ? 'table-Asset-Resolution-data' : 'bar-line-repaired-chart';
    } else if (type == 'Asset Repaired Count') {
      var idSelector = (this.selectGraphThirdType == 'table') ? 'table-data-asset-repaired-count' : 'bar-line-asset-repaired-chart';
    } else {
      var idSelector = (this.selectGraphType == 'table') ? 'table-data-asset-allocatin-count' : 'bar-line-asset-allocatiom-chart';

    }

    let selectedYearForReimbursement;
    if (this.loggedInCompanyFiscalyear == "Jan_Dec") {
      let selectedYear = this.selectedYearForAsset;
      let year = selectedYear.split("-")[0];
      selectedYearForReimbursement = year;
    } else {
      selectedYearForReimbursement = this.selectedYearForAsset;

    }
    // Call the common function from the service
    this.PdfDownload.downloadPDF(
      idSelector, // chartId
      type, // Title
      selectedYearForReimbursement, // Year
      formattedFromDate, // From Date
      formattedtoDate // To Date
    );
  }
  newAllAssetListingData: any = []
  newAssetTotalLength: any = []
  newAssetData: any = [];
  NewassetAllocationData() {


    if (this.checkAuthority?.length > 0) {
      // this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInUserCompanyID}/${this.loggedInUserName}`)
      this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}/${this.loggedInUserCompanyID}`)

        .subscribe((elm: any) => {
          let authorityData = elm.data.filter((elm: any) => elm.authorityName == this.loggedInUserName)
          this.newAllAssetListingData = authorityData.flatMap((record: any) => record.unassignedAssets);
          this.newAssetData = authorityData;
          let empty: any = []
          this.newAllAssetListingData.filter((elm: any) => {
            if (!empty.some((record: any) => record == elm)) {
              empty.push(elm)
            }
          })
          console.log("newAssetTotalLength+++++++++11111111111111111111111111111++++++++++++", this.newAssetTotalLength, empty);

          this.newAssetTotalLength = []
          this.newAssetTotalLength = empty.length
        })
    } else {
      this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}/${this.loggedInUserCompanyID}`)
        .subscribe((elm: any) => {
          this.newAssetData = elm.data;
          this.newAllAssetListingData = elm.data.flatMap((record: any) => record.unassignedAssets);
          console.log(this.newAllAssetListingData);

          let empty: any = []
          this.newAllAssetListingData.filter((elm: any) => {
            if (!empty.some((record: any) => record == elm)) {
              empty.push(elm)
            }
          })
          console.log("inside elese");
          console.log("newAssetTotalLength", this.newAssetTotalLength, empty);
          this.newAssetTotalLength = []
          this.newAssetTotalLength = empty.length
        })
    }

  }


  onClickCard(event: any) {
    // if(this.totalassetCount==0){
    //   return
    // }
    // if(this.newAssetTotalLength==0){
    //   return
    // }
    // if(this.totalrepairedAsset==0){
    //   return
    // }
    // if(this.totalCountRecivedAsset==0){
    //   return
    // }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      allApiData: this.passDataForDetailView,
      loggdingUserId: this.loggedInUserId,
      repairedsset: this.repairedAssetCount,
      newAllAssetListingData: this.newAssetData,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AssetDashboardDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });

  }

}
interface TransformedDataItem {
  xAxisValueData: string;
  seriesValueOneData: number;
}
interface TransformedData extends Array<TransformedDataItem> {
  xAxisName?: string;
  yAxisName?: string;
  seriesLabelOne?: string;
  seriesLabelTwo?: string;
}

